// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__JYxaz","notes":"Notes_notes__16xWS"};